import { render, staticRenderFns } from "./color-filter.vue?vue&type=template&id=c818521c"
import script from "./color-filter.vue?vue&type=script&lang=ts"
export * from "./color-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports